import React from 'react';

export interface BrandLogoProps {
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | number;
  className?: string;
  showText?: boolean;
  textColor?: string;
  onClick?: () => void;
}

const SIZE_MAP: Record<string, { imgSize: string; textClass: string; iconPx: number }> = {
  xs: { imgSize: 'w-6 h-6', textClass: 'text-base font-extrabold', iconPx: 24 },
  sm: { imgSize: 'w-7 h-7', textClass: 'text-lg font-extrabold', iconPx: 28 },
  md: { imgSize: 'w-8 h-8', textClass: 'text-xl font-extrabold', iconPx: 32 },
  lg: { imgSize: 'w-10 h-10', textClass: 'text-2xl font-extrabold', iconPx: 40 },
  xl: { imgSize: 'w-12 h-12', textClass: 'text-3xl font-extrabold', iconPx: 48 }
};

const BRAND_ICON_URL = '/appstatsview-icon.png';
const BRAND_ICON_REMOTE = 'https://images.picxoraimage.ink/users/2pEbRQQHHrSxt7FWkQUusrXj56J2/2026/08/f5771143-5d2f-4616-9669-c8edd5383869-img_2874-2.png';

/**
 * Isolated AppStatsView Company Brand Logo Component
 * Strictly separated from AppIcon, Apple metadata lookups, and third-party app caches.
 */
export const BrandLogo: React.FC<BrandLogoProps> = ({
  size = 'md',
  className = '',
  showText = true,
  textColor = 'text-slate-900',
  onClick
}) => {
  const sizeConfig = typeof size === 'string' && SIZE_MAP[size] ? SIZE_MAP[size] : SIZE_MAP.md;
  const customImgStyle = typeof size === 'number' ? { width: `${size}px`, height: `${size}px` } : undefined;

  return (
    <div
      onClick={onClick}
      className={`inline-flex items-center gap-2.5 select-none ${onClick ? 'cursor-pointer' : ''} ${className}`}
    >
      <div className="relative flex-shrink-0 flex items-center justify-center">
        <img
          src={BRAND_ICON_URL}
          alt="AppStatsView"
          style={customImgStyle}
          className={`${typeof size === 'string' ? sizeConfig.imgSize : ''} rounded-xl object-contain drop-shadow-xs`}
          onError={(e) => {
            const target = e.currentTarget as HTMLImageElement;
            if (target.src !== BRAND_ICON_REMOTE) {
              target.src = BRAND_ICON_REMOTE;
            }
          }}
        />
      </div>
      {showText && (
        <span className={`tracking-tight ${textColor} ${sizeConfig.textClass}`}>
          AppStatsView
        </span>
      )}
    </div>
  );
};

export default BrandLogo;
